var map = {
	"./avispace/app/header/header.component": [
		85008,
		[
			"src_themes_avispace_app_header_header_component_ts"
		]
	],
	"./custom/app/header/header.component": [
		16095,
		[
			"src_themes_custom_app_header_header_component_ts"
		]
	],
	"./dspace/app/header/header.component": [
		39618,
		[]
	],
	"./dspace_new/app/header/header.component": [
		29107,
		[
			"src_themes_dspace_new_app_header_header_component_ts"
		]
	],
	"./reposdes/app/header/header.component": [
		44607,
		[
			"src_themes_reposdes_app_header_header_component_ts"
		]
	],
	"./reposhub/app/header/header.component": [
		50648,
		[
			"src_themes_reposhub_app_header_header_component_ts"
		]
	],
	"./reposhub_new/app/header/header.component": [
		50861,
		[
			"default-src_app_shared_search_search-filters_search-filter_service_ts",
			"default-src_app_shared_search-form_search-form_component_ts",
			"src_themes_reposhub_new_app_header_header_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16722;
module.exports = webpackAsyncContext;